/// <amd-module name="Repos/Discussion/Utils/DiscussionStatus" />
import { DiscussionStatus } from "Repos/Discussion/Common/DiscussionContracts";
import * as Resources from "Repos/Discussion/Resources";
import { IListBoxItem } from "VSSUI/ListBox";

export const discussionStatusListBoxItems: IListBoxItem[] = [
    {
        id: "active",
        data: DiscussionStatus.Active,
        text: Resources.DiscussionStatusActive
    },
    {
        id: "pending",
        data: DiscussionStatus.Pending,
        text: Resources.DiscussionStatusPending
    },
    {
        id: "fixed",
        data: DiscussionStatus.Fixed,
        text: Resources.DiscussionStatusFixed
    },
    {
        id: "wont-fix",
        data: DiscussionStatus.WontFix,
        text: Resources.DiscussionStatusWontFix
    },
    {
        id: "closed",
        data: DiscussionStatus.Closed,
        text: Resources.DiscussionStatusClosed
    }
];

export function isActiveCommentStatus(status: DiscussionStatus): boolean {
    return status === DiscussionStatus.Active || status === DiscussionStatus.Pending;
}
